<template lang="pug">
    .box(:class="layout")
        .image(v-if="image" ref="container")
            img.object-cover.object-center.h-full.w-full(
              v-lazy="image",
              rel="noopener"              
            )
        .image(v-else ref="container")
            img.object-cover.object-center.h-full.w-full(
              src="~@/assets/img/missing.jpg",
              rel="noopener"              
            )
        .info
            .region(v-if="regio && regio.length") {{ regio }}
            .name-task
                h3.name(v-if="name") {{name}}
                .task(v-if="jobTask") {{jobTask}}
            .contact-info(v-if="telephone || email || path || href || desc")
                .desc.rte-area(v-if="layout === 'twoCols'" v-html="desc")
                .tel(v-if="telephone" title="Telefon")
                    font-awesome-icon(v-if="showIcons", icon="phone")
                    strong(v-else) <span class="i">T</span> 
                    a(:href="`tel:${telephone.format}`") {{ telephone.full }}
                .mobilephone(v-if="mobilephone" title="Mobil")
                    font-awesome-icon(v-if="showIcons", icon="mobile")
                    strong(v-else) <span class="i">M</span>
                    a(:href="`tel:${mobilephone.format}`") {{ mobilephone.full }}
                .fax(v-if="fax" title="Fax")
                    font-awesome-icon(v-if="showIcons", icon="fax")
                    strong(v-else) <span class="i">F</span>
                    a(:href="`fax:${fax.format}`") {{ fax.full }}
                .mail(v-if="email")
                    font-awesome-icon(v-if="showIcons", icon="envelope")
                    //- strong(v-else) <span class="i">M</span> 
                    a(:href="`mailto:${email}`", :title="email") {{ email }}
                
</template>

<script>
import { get, trim, startsWith } from '@/helpers';

export default {
    name: 'Element',
    mounted() {
        if (this.id) {
            const state = this.getCollapseState();
            if (state) {
                this.isCollapsed = state[this.id];
            }
        }
    },
    data() {
        return {
            width: 275,
            height: 345
        };
    },
    props: {
        content: {
            type: Object,
            required: true
        },
        region: {
            type: Object
        },
        images: {
            type: Object
        },
        showIcons: {
            type: Boolean
        },
        layout: {
            type: String
        }
    },
    computed: {
        regio() {
            return get(this.region, 'text', '');
        },
        name() {
            return get(this.content, 'title', '');
        },
        jobTask() {
            return get(this.content, 'sub_title', '');
        },
        telephone() {
            let telephone = get(this.content, 'color', '');

            if (telephone) {
                let format = telephone
                    .replace('(0)', '')
                    .replace('-', '')
                    .replace(/\s/g, '')
                    .replace('+49', '0049');
                return {
                    format: format,
                    full: telephone
                };
            }

            return telephone;
        },
        mobilephone() {
            let mobilephone = get(this.content, 'to', '');

            if (mobilephone) {
                let format = mobilephone
                    .replace('(0)', '')
                    .replace('-', '')
                    .replace(/\s/g, '')
                    .replace('+49', '0049');
                return {
                    format: format,
                    full: mobilephone
                };
            }

            return mobilephone;
        },
        fax() {
            let fax = get(this.content, 'bcc', '');

            if (fax) {
                let format = fax
                    .replace('(0)', '')
                    .replace('-', '')
                    .replace(/\s/g, '')
                    .replace('+49', '0049');
                return {
                    format: format,
                    full: fax
                };
            }

            return fax;
        },
        email() {
            return get(this.content, 'cc', '');
        },
        desc() {
            return get(this.content, 'text', '');
        },
        image() {
            const image = get(this.images, 'images.0');
            if (!image) return false;

            const storageRoute = trim(
                `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                '/'
            );

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
            };
            let { w, h } = parameters;
            // let { width, height } = image;
            let aspectRatio = 4 / 5;

            if (w && h) {
                h = 345;
                w = h * aspectRatio;
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`);
            } else if (!w && !h) {
                h = 345;
                w = h * aspectRatio;
                fit += `&h=${h}&w=${w}`;
            }

            return {
                h,
                w,
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`
            };
        },

        hyperlink() {
            return get(this.content, 'hyperlink') || {};
        },
        href() {
            let href = false;

            if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href;
                switch (this.hyperlink.type) {
                    case 'external':
                        if (!startsWith(link, 'https://') && !startsWith(link, 'http://')) href = `https://${link}`;
                        else href = link;
                        break;

                    case 'mailto':
                        href = `mailto:${link}`;
                        break;

                    case 'tel':
                        href = `tel:${link}`;
                        break;
                }
            }

            return href;
        },
        target() {
            return get(this.hyperlink, 'target') || '_self';
        },
        path() {
            if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
                return this.hyperlink.menuItem.path;
            else return false;
        },
        odd() {
            return this.index % 2 == 0;
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item);
            this.mouseover = true;
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item);
                this.mouseover = false;
            }, this.delay);
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

$person-bg-color: #a3aebb


.box
    @apply h-full
    &.twoCols
        @apply flex flex-col text-white
        background-color: $color-primary
        border-radius: 5px
        @screen sm
            @apply flex-row
            min-height: 350px

        .region
            @apply uppercase mb-2 bg-white block font-bold
            color: $color-primary
            margin-left: -1.5rem
            margin-top: -1.5rem
            padding: 0.5rem 1.5rem
            width: calc(100% + 3rem)
            border-right: 1px solid $person-bg-color
            border-left: 1px solid $person-bg-color
            @screen sm
               border-radius: 0 5px 0 0
               border-top: 1px solid $person-bg-color
               border-left: 0


        .image
            img
                @apply w-full h-full
                border-radius: 5px 5px 0 0
                border: 1px solid $person-bg-color
                @screen sm
                    border-radius: 5px 0 0 5px
                    width: 180px
                @screen lg
                    min-width: 200px
        .info
            @apply p-6 w-full

            @screen lg
                width: 282px
            @screen xl
                @apply w-full
            .name-task
                min-height: auto
                .name
                    @apply mt-0
            .contact-info
                .desc
                    @apply mb-3
                    h2,h4
                        color: #fff !important


    &.oneCol
        @apply text-base flex flex-col text-white
        background-color: $color-primary
        border-radius: 5px 5px 0 0
        .region
            @apply uppercase mb-2 bg-white block  font-bold
            margin-left: -1rem
            margin-top: -1rem
            padding: 0.5rem 1rem
            width: calc(100% + 2rem)
            color: $person-bg-color
            border-left: 1px solid $person-bg-color
            border-right: 1px solid $person-bg-color

        .image
            border-radius: 5px 5px 0 0
            border: 1px solid $person-bg-color
        .info
            @apply flex flex-col justify-between p-4
            .name-task
                min-height: 50px


    .image
        @apply overflow-hidden flex-shrink-0 h-auto
    .info
        @apply w-full
        .name-task
            .name
                @apply font-semibold mb-0
                font-family: $font
            .task
                @apply font-normal
        .contact-info
            @apply mt-3
            .desc::v-deep a
                @apply text-white
                &:hover
                    @apply text-black

            a:hover
                @apply text-black
            .svg-inline--fa
                @apply mr-2
                min-width: 20px
            strong
                font-weight: bold
            .mail a
                @apply underline

            .i
                @apply inline-block
                width: 20px

            .tel,
            .mobilephone,
            .fax,
            .mail
                @apply w-full overflow-hidden
                transition: all .3s ease-in-out 0s
                text-overflow: ellipsis
                white-space: nowrap
                &:hover
                    overflow: visible
                    white-space: normal
</style>
